export default __webpack_public_path__ + "static/media/history-icon.c712ab5a.svg";